import { render, staticRenderFns } from "./historical-arbitrage-transaction-details.vue?vue&type=template&id=2d696256&scoped=true&"
import script from "./historical-arbitrage-transaction-details.vue?vue&type=script&lang=js&"
export * from "./historical-arbitrage-transaction-details.vue?vue&type=script&lang=js&"
import style0 from "./historical-arbitrage-transaction-details.vue?vue&type=style&index=0&id=2d696256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d696256",
  null
  
)

export default component.exports